import React,{useEffect} from 'react';
import MenuObjeto from './menuObjeto.jsx';
import LoaderHOC from '../../UI/HOC/LoaderHOC.js';
import { baseUrl, UtilitariosRutas } from '../../../request/RutasConfig.jsx';
import {removejscssfile} from '../../Util/Util.jsx';

//class Menu extends React.Component {
function Menu (props){   
    // constructor(props){
    //     super(props);
    //     this.state= { consMenu:{empleado:1, parametros:2, procesos:3, genInterfaces:4,reportes:5, administrativo:6 } ,
    //                   consMenuInter:{pagoBancos:1, interfazBancos:2, interfzaTerceros:3,correos:4 }
    //     };
    // }

    const scriptJavaActualizar =()=> {

        removejscssfile("webslidemenu.js", "js") //remove all occurences of "somescript.js" on page

        //         //Se metido el script por que cuando es asincronico la consulta a base de datos y el llenado se hace despues de montado el react, la funcionalidad del java script saparece

        const script = document.createElement("script");
        script.src = UtilitariosRutas.Webslidemenu;   //baseUrl + "Public/lib/utilitarios/webslidemenu.js";
        script.async = false;      
        document.body.appendChild(script);  
    }

    useEffect(scriptJavaActualizar)

    //render() {
        const { datosMenu ,onCerrarSesion } = props;
        const consMenu = {empleado:1, parametros:2, procesos:3, genInterfaces:4,reportes:5, administrativo:6 } ;
        const consMenuInter={pagoBancos:1, interfazBancos:2, interfzaTerceros:3,correos:4 }
        var menu = datosMenu.map(function (dato, index) {
            return (<MenuObjeto key={index} datosMenuObjeto={dato} consMenu = {consMenu} consMenuInter ={consMenuInter} onCerrarSesion = {onCerrarSesion}/>) 
        });
        return (
            <div className="wsmenucontainer clearfix">
                <div className="overlapblackbg"></div>
                <div className="wsmobileheader clearfix"> <a id="wsnavtoggle" className="animated-arrow"><span></span></a> </div>
                <div className="headerfull">
                    {/*Main Menu HTML Code-->*/}
                    <div className="wsmain">
                        <nav className="wsmenu clearfix">                            
                            <ul className="mobile-sub wsmenu-list">
                                {menu}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>        
        );
    //}
};
export default LoaderHOC('datosMenu')(Menu); 


